import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Chat from "../images/chat.svg";
import homeIcon from "../images/home.svg";
import person from "../images/person.svg";
import search from "../images/search.svg";
import Interra from "../images/logo.png";
import Image1 from "../images/jacob.png";
import influencers from '../sampleJSON/trending.json'
import Insta from "../images/instagram.svg";
import Youtube1 from "../images/youtube.svg";
import Twitter from "../images/twitter.svg";
import Navbar from "./navBar";
import {Pagination,Navigation} from 'swiper';
import SwiperCore, { Keyboard, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.scss'; // core Swiper
import 'swiper/modules/navigation/navigation.scss'; // Navigation module
import 'swiper/modules/pagination/pagination.scss'; // Pagination module
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import InfluencerCard from "./influencerCard";
import "./viewInfluencer.css";
import NavbarInfluencer from "./NavbarInfluencer";
// import { useState } from "react";
import { useEffect } from "react";

function ViewInfluencer() {
  /*
       Setting the User Details Here
   */
  let influarray = influencers.influencers;
  const navi = useNavigate();
  const [name, setName] = useState("");
  const [photo, setPhoto] = useState("");

  useEffect(() => {
    setName(localStorage.getItem("Name"));
    setPhoto(localStorage.getItem("PhotoURL"));

    //settimeout for 2 seconds
    setTimeout(() => {
      console.log("tst");
    }, 2000);
  }, []);

  function ClickLogo(){
    let path = `/`; 
    navi(path);
}
  const { Name, Profile, Tags } = useParams();
  console.log(Name, Profile, Tags);
  // const location = useLocation()
  // const { Name,Profile,Tags } = location.state

  // console.log(Tags)
  // var mytags = Tags.split(' ');
  const [influencerList, setInfluencerList] = useState([]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    if (id === "i-btn") {
      setInfluencerList(influencerList.append(value));
      console.log(influencerList);
    }
  };
  const logout = () => {
    localStorage.clear();
    navi("/");
  };
  return (
    <div className="outer2">
      {/* <NavbarInfluencer/> */}
      <Navbar/>
      {/* <div className="inner1">
        <a href="/" className="H-txt">
          {" "}
          <img src="/images/home.png" className="b1-icon1" alt="home"></img>
        </a>
        <a href="/infsearch" className="H-txt">
          <img
            src="/images/search-coloured.png"
            className="b1-icon2"
            alt="search"
          ></img>
        </a>
        <a href="/chat" className="H-txt">
          {" "}
          <img
            src="/images/message.png"
            className="b1-icon3"
            alt="message"
          ></img>
        </a>
        <a href="/influencer-details" className="H-txt">
          {" "}
          <img
            src="/images/profile-coloured.png"
            className="b1-icon4"
            alt="person"
          ></img>
        </a>
      </div> */}
      

      <img src={Interra} className="logo3" onClick={ClickLogo}></img>
      <button onClick={logout} className="logout3">
        Logout
      </button>
      {/* <img src={NotificationsIcon} className="notification"></img> */}
      {/* <CircleNotificationsIcon className="notification" /> */}
      {/* <div className="inner2">
                <img src={homeIcon} className="icons2"></img>
                <img src={Chat} className="icons2"></img>
                <img src={person} className="icons2"></img>
                <img src={search} className="icons2"></img>
            </div> */}
      <div className="grid">
        <div className="row">
          <img src="/images/45.png" className="profile_img1 first-third"></img>
          <div className="second-third">
            <div className="name ">Emily Watson</div>
            <div className="details_inf">
              @emilywatson
              <br />
              Female | 69 | New York
            </div>
            <div className="btn-m">
              <button className="btn-msg">Message</button>
            </div>

            <hr />
          </div>
          <div className="third-third">
            <div className="reach">
              <p>
                <b> 5K </b>Reach
              </p>
            </div>
            <div className="reach">
              <p>
                <b className="big-font">14</b> worked with <br /> brands
              </p>
            </div>

            {/* <div className="vi-socialsimg">
            <img src={Insta} className="vi-img3"></img>
            <img src={Youtube1} className="vi-img4"></img>
          </div> */}
          <div className="links">
            <div className="socials">
              <div className="div-around-insta">
                <img src={Youtube1} className="si-img3"></img>
              </div>
              <div className="div-around-insta">
                <img src={Insta} className="si-img3"></img>
                <p className="number">250k</p>
              </div>
              <div className="div-around-insta">
                <img src={Twitter} className="si-img3"></img>
                <p className="number">150k</p>
              </div>
            </div>
            </div>
          </div>
        </div>

        <div className="row">
          {/* {mytags.map(item => <li>{item}</li>)} */}
          <div className="column2">
            <div className="i-opt">
              <button
                className="s-btn1"
                id="i-btn"
                onClick={(e) => handleInputChange(e)}
                value="Life Style"
              >
                Life Style
              </button>
              <button
                className="s-btn1"
                id="i-btn"
                onClick={(e) => handleInputChange(e)}
                value="Food"
              >
                Food
              </button>
              <button
                className="s-btn1"
                id="i-btn"
                onClick={(e) => handleInputChange(e)}
                value="Sports"
              >
                Sports
              </button>
              <button
                className="s-btn1"
                id="i-btn"
                onClick={(e) => handleInputChange(e)}
                value="Sports"
              >
                Health
              </button>
              {/* <button className='s-btn1' id='i-btn' onClick={(e) => handleInputChange(e)} value='Health'>Health</button>
                            <button className='s-btn1' id='i-btn' onClick={(e) => handleInputChange(e)} value='Food'>Food</button>
                            <button className='s-btn1' id='i-btn' onClick={(e) => handleInputChange(e)} value='Finance'>Finance</button>
                            <button className='s-btn1' id='i-btn' onClick={(e) => handleInputChange(e)} value='Finance'>Finance</button> */}
            </div>
          </div>
        </div>
        <p className="vi-p1">Recent posts</p>
        <div className="vi-rp">
                  <Swiper
                    modules={[Mousewheel,Keyboard,Pagination,Navigation]}
                    spaceBetween={10}
                    slidesPerView={6}
                    pagination={{ clickable: true }}
                    Mousewheel={{eventTarget:'.vi-rp'}}
                    Keyboard
                    direction='horizontal'
                    Navigation={true}
                    className='vi-rp2'
                    breakpoints={{
                        300: {
                          slidesPerView: 2,
                          spaceBetween: 20,
                        },
                        650: {
                          slidesPerView: 3,
                          spaceBetween: 40,
                        },
                        1024: {
                          slidesPerView: 3,
                          spaceBetween: 20,
                        },
                    }}>
                    {
                        influarray.map((element) => {
                            return <div className="vi-card" key={element.id}>
                                <SwiperSlide>
                                <InfluencerCard username={element.userName} Name={element.Name} profileImg={element.imgUrl} Img={element.imgUrl}/>
                                </SwiperSlide>
                            </div>
                        })
                    }
                  </Swiper>
        </div>
      </div>
    </div>
  );
}

export default ViewInfluencer;
